// @flow
import {REHYDRATE} from 'redux-persist';
import {updateCustomTranslations} from '../../lib/i18n';
import theme, {setTheme} from '../../theme-config';
import type {ThemeActionsType} from './actions';

export default (state: string = theme.name, action: ThemeActionsType) => {
  switch (action.type) {
    case 'UPDATE_THEME':
      return action.payload.theme;
    case REHYDRATE:
      if (action.payload) {
        const incoming = action.payload.theme;
        if (incoming) {
          setTheme(incoming);
          updateCustomTranslations(false);
          return incoming;
        }
      }
      return state;
    default:
      return state;
  }
};
